import horizontalColor from "../../assets/octopus-agro-horizontal-color.svg";
import horizontalNegativo from "../../assets/octopus-agro-horizontal-negative.svg";
import isotipoNegativo from "../../assets/octopus-agro-isotipo-negative.svg";
import { cn } from "../../ui/utils";

/**
 * Único punto de uso del logo (guía de marca p. 7, 10–12). Solo se usan los
 * SVG del kit, sin recolorear ni deformar. Sobre Dark Spruce va la versión
 * `negative`; el tamaño mínimo digital es isotipo 16 px y horizontal 180 px,
 * por eso el ancho de cada variante está fijo y no se ofrece otro.
 */
export interface LogoProps {
  variante: "isotipo" | "horizontal";
  /** `oscuro`: sobre Dark Spruce/Onyx. `claro`: sobre fondos claros. */
  fondo?: "oscuro" | "claro";
  className?: string;
}

export function Logo({ variante, fondo = "oscuro", className }: LogoProps) {
  if (variante === "isotipo") {
    // El kit solo trae el isotipo blanco; el shell lo usa siempre sobre Dark Spruce.
    return <img src={isotipoNegativo} alt="Octopus Agro" width={28} height={28} className={cn("h-7 w-7 shrink-0", className)} />;
  }
  return (
    <img
      src={fondo === "oscuro" ? horizontalNegativo : horizontalColor}
      alt="Octopus Agro"
      width={180}
      className={cn("h-auto w-[180px] shrink-0", className)}
    />
  );
}
